import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import Modal from '../../../core/Modal';
import { StyledModalContent } from '../../../core/Modal/style';

export const StyledModal = styled(Modal)`
  ${mediaqueries.greaterThan('desktop')`
    ${StyledModalContent} {
       overflow: hidden;
    }
  `};
`;

export const StyledBoxContent = styled.div`
  padding: 0 ${rem('10px')};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0;
    max-height: 455px;
    overflow: auto;
  `};
`;

export const StyledWrapper = styled.div`
  padding-top: ${rem('20px')};
`;

export const StyledHighlightWrapper = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  padding: ${rem('50px')} ${rem('70px')} ${rem('100px')} ${rem('70px')};
  box-sizing: border-box;
  height: ${rem('455px')};
`;
